import { render, staticRenderFns } from "./Rrss.vue?vue&type=template&id=46ffb36c&scoped=true&"
import script from "./Rrss.vue?vue&type=script&lang=js&"
export * from "./Rrss.vue?vue&type=script&lang=js&"
import style0 from "./Rrss.vue?vue&type=style&index=0&id=46ffb36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffb36c",
  null
  
)

export default component.exports